import { render, staticRenderFns } from "./SplashLoader.vue?vue&type=template&id=be8b904a&scoped=true&"
import script from "./SplashLoader.vue?vue&type=script&lang=js&"
export * from "./SplashLoader.vue?vue&type=script&lang=js&"
import style0 from "./SplashLoader.vue?vue&type=style&index=0&id=be8b904a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8b904a",
  null
  
)

export default component.exports